const convertSchemaToConfig = (data: any)=>{
    let config: any = {
        "sections": {}
    };
    Object.entries(data)?.map((item: any) => {
        const [displayKey, json] = item;
        Object.entries(json)?.map((sectionItem: any) => {
            const [sectionKey, sectionValue] = sectionItem;
            if (!config.sections[sectionKey]) {
                config.sections[sectionKey] = { subsections: {} };
            }
            Object.entries(sectionValue)?.map((subsectionItem: any) => {
                const [subsectionKey, subsectionValue] = subsectionItem;
                config.sections[sectionKey].subsections[subsectionKey] = subsectionValue;
            });
        });
    });
    return config;
}

export default convertSchemaToConfig;